import { init } from '@sentry/browser'

const isProduction = process.env.NODE_ENV === 'production'
if (isProduction) {
  init({
    dsn: 'https://bdd523c5ae8745b99609918d2ad34284@sentry.yournext.agency/48'
  })
}

